import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import bgImg from "../assets/bgIMG.png";
import css from "../assets/css.png";
import git from "../assets/git.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import mu5 from "../assets/mu5.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import django from "../assets/django.png";
import django_dark from "../assets/django-dark.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.svg";

const images = {
    email,
    mobile,
    css,
    git,
    html,
    javascript,
    mu5,
    node,
    django_dark,
    python,
    django,
    react,
    redux,
    sass,
    about01,
    about02,
    about03,
    about04,
    profile,
    circle,
    logo,
    bgImg,
};
export default images;
